import { createFieldset } from './fieldset';

export default {
  title: 'Aggiungi Prodotto',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'products',
            method: 'POST'
          }
        },
        fieldsets: [createFieldset]
      }
    }
  ]
};
